var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('dashboard-info-block'),_c('div',{staticClass:"row row-equal"},[_c('div',{staticClass:"flex xs12 lg6"},[_c('dashboard-tabs')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }